(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('advertising-source', {
            /*
            parent: 'entity',
            url: '/advertising-source?page&sort&search',
            */
            parent: 'dictionary',
            url: '/advertising-source?page&sort&search&actualFilter',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.advertisingSource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advertising-source/advertising-sources.html',
                    controller: 'AdvertisingSourceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                actualFilter: {
                    value: 'true',
                    squash: true
                },
                sort: {
                    /*
                    value: 'id,asc',
                    */
                    value: 'name,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        actualFilter: $stateParams.actualFilter,
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advertisingSource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('advertising-source-detail', {
            parent: 'advertising-source',
            url: '/advertising-source/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'telestatApp.advertisingSource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/advertising-source/advertising-source-detail.html',
                    controller: 'AdvertisingSourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('advertisingSource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AdvertisingSource', function($stateParams, AdvertisingSource) {
                    return AdvertisingSource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'advertising-source',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('advertising-source-detail.edit', {
            parent: 'advertising-source-detail',
            url: '/detail/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MARKETER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advertising-source.new', {
            parent: 'advertising-source',
            url: '/new',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                caption: null,
                                monthBudget: null,
                                color: null,
                                uploadPhoneFormat: null,
                                /*
                                autodetect: false,
                                */
                                autodetect: true,
                                code: null,
                                /*
                                actual: false,
                                */
                                actual: true,
                                externalId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('advertising-source');
                });
            }]
        })
        .state('advertising-source.edit', {
            parent: 'advertising-source',
            url: '/{id}/edit',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN', 'ROLE_MARKETER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-dialog.html',
                    controller: 'AdvertisingSourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('advertising-source.delete', {
            parent: 'advertising-source',
            url: '/{id}/delete',
            data: {
                /*
                authorities: ['ROLE_USER']
                */
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/advertising-source/advertising-source-delete-dialog.html',
                    controller: 'AdvertisingSourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AdvertisingSource', function(AdvertisingSource) {
                            return AdvertisingSource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('advertising-source', null, { reload: 'advertising-source' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
